import { useState, useEffect } from 'react';
import {
  AgxRow,
  AgxLabel,
  AgxRadio,
  AgxTextInput,
  AgxColumn,
} from '@urbanx/agx-ui-components';
import { CoolingOffCondition, WaiverOfCoolingOff } from './types';
import './WaiverOfCoolingOff.scss';
import { parseStringToNumber } from 'utils/numbers';

interface WaiverOfCoolingOffProps {
  id: string;
  validate?: boolean;
  onValueChanged: (value: WaiverOfCoolingOff) => void;
  defaultValue?: WaiverOfCoolingOff;
}

const WaiverOfCoolingOffComponent = ({
  id,
  defaultValue,
  onValueChanged,
  validate,
}: WaiverOfCoolingOffProps) => {
  const [localError, setLocalError] = useState('');
  const [waiverOfCoolingOff, setWaiverOfCoolingOff] = useState({
    coolingOffCondition: defaultValue?.coolingOffCondition,
    shortenCoolingOffDays: defaultValue?.shortenCoolingOffDays,
  });

  useEffect(() => {
    onValueChanged({
      ...waiverOfCoolingOff,
    });
  }, [waiverOfCoolingOff]);

  useEffect(() => {
    if (validate) {
      if (
        waiverOfCoolingOff.coolingOffCondition ===
        CoolingOffCondition.IncludeShorteningOfCoolingOff
      ) {
        if ((waiverOfCoolingOff.shortenCoolingOffDays ?? 0) > 4)
          setLocalError("Days can't exceed 4 days.");
        else if (!waiverOfCoolingOff.shortenCoolingOffDays)
          setLocalError('Enter days.');
        else setLocalError('');
      }
    }
  }, [validate, waiverOfCoolingOff.shortenCoolingOffDays]);

  return (
    <AgxColumn mediumGap fill>
      <AgxRow fill spaceBetween>
        <AgxLabel medium>Waiver/Shortening of cooling off</AgxLabel>
      </AgxRow>
      <div className="agxRadio-group">
        <AgxRadio
          id="NotRequired"
          label="Not Required"
          onCheckChanged={() =>
            setWaiverOfCoolingOff(prev => ({
              ...prev,
              coolingOffCondition: undefined,
              shortenCoolingOffDays: undefined,
            }))
          }
          checked={
            waiverOfCoolingOff.coolingOffCondition !==
              CoolingOffCondition.IncludeShorteningOfCoolingOff &&
            waiverOfCoolingOff.coolingOffCondition !==
              CoolingOffCondition.IncludeWaiverOfCoolingOff
          }
        />
        <AgxRadio
          id="NotRequired"
          label="Include Waiver of Cooling Off"
          onCheckChanged={() =>
            setWaiverOfCoolingOff(prev => ({
              ...prev,
              coolingOffCondition:
                CoolingOffCondition.IncludeWaiverOfCoolingOff,
              shortenCoolingOffDays: undefined,
            }))
          }
          checked={
            waiverOfCoolingOff.coolingOffCondition ===
            CoolingOffCondition.IncludeWaiverOfCoolingOff
          }
        />
        <AgxRadio
          id="IncludeShorteningOfCoolingOff"
          label="Include Shortening of Cooling Off"
          onCheckChanged={() =>
            setWaiverOfCoolingOff(prev => ({
              ...prev,
              coolingOffCondition:
                CoolingOffCondition.IncludeShorteningOfCoolingOff,
            }))
          }
          checked={
            waiverOfCoolingOff.coolingOffCondition ===
            CoolingOffCondition.IncludeShorteningOfCoolingOff
          }
          subContent={
            waiverOfCoolingOff.coolingOffCondition ===
            CoolingOffCondition.IncludeShorteningOfCoolingOff
              ? [
                  <AgxColumn mediumGap>
                    <AgxLabel medium>Shorten cooling off period to</AgxLabel>
                    <AgxColumn extraClasses={'days'}>
                      <AgxTextInput
                        id="ShorteningOfCoolingOffDays"
                        small
                        noHeader
                        numberOnly
                        noOptionalLabel
                        maxLength={2}
                        defaultValue={waiverOfCoolingOff.shortenCoolingOffDays?.toString()}
                        onInputValueChange={({ value }) => {
                          const parsedValue = parseStringToNumber(value);

                          setWaiverOfCoolingOff(prev => ({
                            ...prev,
                            shortenCoolingOffDays: parsedValue,
                          }));
                        }}
                        rightIcon={<AgxLabel>day(s)</AgxLabel>}
                        error={localError}
                      />
                    </AgxColumn>
                  </AgxColumn>,
                ]
              : undefined
          }
        />
      </div>
    </AgxColumn>
  );
};

export default WaiverOfCoolingOffComponent;
